import {
	ADMINCREATERISKRULEMAPPING_SUCCESS,
	ADMINCREATERISKRULEMAPPING_FAILED,
	RESET_ADMINCREATERISKRULEMAPPING,
	LOADING_ADMINCREATERISKRULEMAPPING,
	NETWORK_ERROR_ADMINCREATERISKRULEMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminCreateRiskRuleMapping = () => {
	return { type: RESET_ADMINCREATERISKRULEMAPPING };
};

const adminCreateRiskRuleMapping =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINCREATERISKRULEMAPPING });
		await adminServices
			.post("createPartnerRiskRuleMapping", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminCreateRiskRuleMappingsuccess(res.data));
						break;
					default:
						dispatch(adminCreateRiskRuleMappingFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINCREATERISKRULEMAPPING,
					payload: err
				});
			});
	};
function adminCreateRiskRuleMappingsuccess(data) {
	return {
		type: ADMINCREATERISKRULEMAPPING_SUCCESS,
		payload: data
	};
}
function adminCreateRiskRuleMappingFailed(data) {
	return {
		type: ADMINCREATERISKRULEMAPPING_FAILED,
		payload: data
	};
}

export { resetadminCreateRiskRuleMapping, adminCreateRiskRuleMapping };
